//MADE FOLLOWING CHANGES ON 6THNOV2025 THAT HAVE NOT BEEN PUT IN THE COMMENTS.

import * as React from "react";
import { useState, useEffect } from "react";
import '@cloudscape-design/global-styles/index.css';  //ADDED THIS TO SET UP CLOUDSCAPE IN THIS APPLICATION (23OCT2025).
import logo from "./logo.svg";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import { signOut, getCurrentUser, signInWithRedirect } from "aws-amplify/auth";
// 🎯 CORRECTED IMPORTS: Removed non-existent ListOutputItem
import { uploadData, list, getUrl, TransferProgressEvent } from "aws-amplify/storage"; 
import { Hub } from "aws-amplify/utils";
import config from "./aws-exports";
import {
  Button as AmplifyButton,       // "as AmplifyButton" text added to handle conflict between Amplify UI and Cloudscape Design System components (23OCT2025).
  View,
  Card,
} from "@aws-amplify/ui-react";
import { Button as CloudscapeButton,         //ADDED THIS TO SET UP CLOUDSCAPE IN THIS APPLICATION (23OCT2025).
  Container,                                //ADDED THIS TO SET UP CLOUDSCAPE IN THIS APPLICATION (23OCT2025).
  Header 									//ADDED THIS TO SET UP CLOUDSCAPE IN THIS APPLICATION (23OCT2025).
} from '@cloudscape-design/components';  	//ADDED THIS TO SET UP CLOUDSCAPE IN THIS APPLICATION (23OCT2025).

// Define types for better TypeScript support
interface AuthUser {
  username: string;
  userId: string;
  signInDetails?: any;
}

interface HubPayload {
  event: string;
  data?: any;
}

interface UploadedFile {
  name: string;
  key: string;
  uploadTime: string;
}

interface ProcessedFile {
  key: string;
  name: string;
  size: number;
}

// 🎯 DEFINE BUCKET NAMES AND PREFIXES
const UPLOAD_BUCKET_NAME = 'strteamamplifyapp-storage-6e109dce3a8b3-dev';          // changed from 'fmeawocc'; on 5thNov2025. changed from woccfmea to this on 5thNov2025.
const DOWNLOAD_BUCKET_NAME = 'strteamamplifyapp-storage-6e109dce3a8b3-dev'   // changed from 'fmeawccwtranslation'; on 5thNov2025.
const UPLOAD_BUCKET_REGION = 'us-west-2';       //changed from us-east-2 to us-west-2 on 5thNov2025.
const DOWNLOAD_BUCKET_REGION = 'us-west-2';     //changed from 'us-east-1'; on 5thNov2025.
const PROCESSED_FILES_PREFIX = ''; // Root of the destination bucket
const UPLOAD_KEY_PREFIX = '';
//const UPLOAD_KEY_PREFIX = 'fmea-uploads/'; I THINK, THIS STATEMENT WAS GIVING ERROR.

// Configure OAuth redirects dynamically.  THIS BLOCK WAS COMMENTED, AND REPLACED WITH THE BLOCK FROM LINE#54 TO 78 TO OVERCOME ISSUE WITH FILE NOT GETTING UPLOADED.
config.oauth = {
  ...config.oauth,
  redirectSignIn: `${window.location.origin}/`,
  redirectSignOut: `${window.location.origin}/`,
};

// Override storage settings at app level
config.aws_user_files_s3_bucket = UPLOAD_BUCKET_NAME; // 'fmeawocc'
config.aws_user_files_s3_bucket_region = UPLOAD_BUCKET_REGION; // 'us-east-2'
(config as any).Storage = {
  AWSS3: {
    buckets: [
      { name: UPLOAD_BUCKET_NAME, region: UPLOAD_BUCKET_REGION },
      { name: DOWNLOAD_BUCKET_NAME, region: DOWNLOAD_BUCKET_REGION }
    ],
  },
};

Amplify.configure(config);

// 🎯 FINAL FIX: Define the Storage config variables (from your App.tsx) 
// and merge them with aws-exports for reliable lookup.

// 1. Prepare the custom/dynamic config overrides
//const customConfig = {
    //...config,
    //oauth: {
        //...config.oauth,
        //redirectSignIn: `${window.location.origin}/`,
        //redirectSignOut: `${window.location.origin}/`,
    //},
    // 2. Ensure Storage configuration is well-formed right before configure
    //Storage: {
        //AWSS3: {
            //buckets: [
                //{ name: UPLOAD_BUCKET_NAME, region: UPLOAD_BUCKET_REGION },
                //{ name: DOWNLOAD_BUCKET_NAME, region: DOWNLOAD_BUCKET_REGION },
                // Include the default bucket from aws-exports for stability
                //{ name: config.aws_user_files_s3_bucket, region: config.aws_user_files_s3_bucket_region }
            //],
        //},
    //},
//};

//const customConfig = {
    // 1. Core AWS and Cognito settings (copied from original config)
    //aws_project_region: config.aws_project_region,
    //aws_cognito_identity_pool_id: config.aws_cognito_identity_pool_id,
    //aws_cognito_region: config.aws_cognito_region,
    //aws_user_pools_id: config.aws_user_pools_id,
    //aws_user_pools_web_client_id: config.aws_user_pools_web_client_id,
    //federationTarget: config.federationTarget,
    //aws_cognito_username_attributes: config.aws_cognito_username_attributes,
    //aws_cognito_mfa_configuration: config.aws_cognito_mfa_configuration,
    //aws_cognito_verification_mechanisms: config.aws_cognito_verification_mechanisms,

    // 2. OAuth settings (use the version from the imported config)
    //oauth: {
		//...config.oauth,
		//redirectSignIn: `${window.location.origin}/`,
        //redirectSignOut: `${window.location.origin}/`,
	//},
    // 3. Default Storage settings (for back-compatibility)
    //aws_user_files_s3_bucket: UPLOAD_BUCKET_NAME,
    //aws_user_files_s3_bucket_region: UPLOAD_BUCKET_REGION,

    // 4. 🔑 CRITICAL: Explicitly define the Storage block with custom buckets
    //Storage: {
        //AWSS3: {
            //buckets: [
                //{ name: UPLOAD_BUCKET_NAME, region: UPLOAD_BUCKET_REGION },
                //{ name: DOWNLOAD_BUCKET_NAME, region: DOWNLOAD_BUCKET_REGION }//,
                //{ name: config.aws_user_files_s3_bucket, region: config.aws_user_files_s3_bucket_region }
            //],
        //},
    //},
//};
// 3. Configure Amplify with the complete, merged object.
//Amplify.configure(customConfig);



function App() {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadStatus, setUploadStatus] = useState<string>('');
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [processedFiles, setProcessedFiles] = useState<ProcessedFile[]>([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isListing, setIsListing] = useState(false);

  // Add CSS for logo animation and file upload styling (unchanged)
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
      .spinning-logo {
        animation: spin 20s linear infinite;
      }
      .file-upload-area {
        border: 2px dashed #5a6c7d;
        border-radius: 8px;
        padding: 2rem;
        margin: 1rem 0;
        background-color: #34495e;
        transition: border-color 0.3s ease;
        cursor: pointer;
      }
      .file-upload-area:hover {
        border-color: #ff9900;
      }
      .file-upload-area.drag-over {
        border-color: #4CAF50;
        background-color: #2c3e50;
      }
      .file-input-label {
        display: inline-block;
        padding: 10px 20px;
        background-color: #ff9900;
        color: white;
        border-radius: 4px;
        cursor: pointer;
        border: none;
        transition: background-color 0.3s ease;
      }
      .file-input-label:hover {
        background-color: #e68900;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);
  

  // Function to get current authenticated user (unchanged)
  const getUser = async (): Promise<AuthUser | null> => {
    try {
      const userData = await getCurrentUser();
      return userData as AuthUser;
    } catch (error) {
      console.log("Not signed in");
      return null;
    }
  };

  // 🎯 FINAL FIX: Using 'as any' for List item type to bypass strict TS check
  const fetchProcessedFiles = React.useCallback(async () => {
    if (!user) return;

    setIsListing(true);
    try {
	  // Use the user's username to build the correct path   			//ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
      const userSpecificPrefix = `Translated_public/${user.username}/`;	//ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
	  
	  console.log('Fetching from bucket:', DOWNLOAD_BUCKET_NAME);   //ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
	  console.log('Looking in user-specific prefix:', userSpecificPrefix); 		  //ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
      //console.log('Looking in user-specific prefix:', 'Translated_public/');      //ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
	  
      const result = await list({   		//COMMENTED ON 6THNOV2025.
		prefix: 'Translated_public/', // Look in the correct folder.
		//prefix: userSpecificPrefix, 				// Use user-specific path, uncommented from before "," on 4thNov2025.
        options: {									//COMMENTED ON 23OCT2025 TO OVERCOME BUCKET LOOKUP ISSUES.Uncommented on 4thNov2025.	
		  bucket: {
			bucketName: DOWNLOAD_BUCKET_NAME,
			region: DOWNLOAD_BUCKET_REGION
		  }
        }
      });									//COMMENTED ON 6THNOV2025.
	  
	  //const result = await list(userSpecificPrefix, {	//ADDED THIS BLOCK ON 6TH NOV2025 REPLACING THE BLOCK FROM ABOVE.
		  //bucket: DOWNLOAD_BUCKET_NAME,						//ADDED THIS BLOCK ON 6TH NOV2025 REPLACING THE BLOCK FROM ABOVE.
		  //region: DOWNLOAD_BUCKET_REGION,					//ADDED THIS BLOCK ON 6TH NOV2025 REPLACING THE BLOCK FROM ABOVE.
	  //}); 													//ADDED THIS BLOCK ON 6TH NOV2025 REPLACING THE BLOCK FROM ABOVE.
	  
	  console.log("All Translated_public/ files:", result.items.map(i => i.key)); //ADDED ON 6thNov2025.
	  console.log('Raw S3 list result:', result);                   //ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
      console.log('Number of items found:', result.items.length);   //ADDED TO DEBUG DOWNLOAD FUNCTIONALITY.
	  console.log("Listing all items returned by S3:");    			//ADDED THIS ON 6thNov2025.
	  result.items.forEach((item: any) => console.log(item.key));	//ADDED THIS ON 6thNov2025.
	
	  const files = result.items
		.filter((item: any) => //{									//replaced item with (item: any) on 6thNOV2025.
		  //return //item.key &&                 					//COMMENTED ON 6THNOV2025.					
			item.key?.endsWith('.xlsx') &&					//ADDED ? ON 6THNOV2025.				
			item.key.includes('-w_CC-translation')//; // Only processed files with suffix. // added -translation ON 6thNov2025.
		)
		.map(item => {
		  const fileName = item.key?.split('/').pop() || '';
		  //const displayName = fileName.replace('-w_CC-translation.xlsx', '.xlsx');  // added -translation ON 6thNov2025.
		  return {
			name: fileName, // Show original name or keep processed name. changed displayName to fileName on 6thNov2025.
			key: item.key, // || '', //commented after || on 6THNOV2025.
			uploadTime: item.lastModified?.toLocaleString() || '',
			size: item.size || 0
		  };
		});
		
	  setProcessedFiles(files);
	  console.log('Found ${files.length} processed files in folder: : ${userSpecificPrefix}');
	} catch (error) {
	  console.error('Error listing processed files:', error);
	  setProcessedFiles([]);
	} finally {
	  setIsListing(false);
	}
  }, [user]);				// REMOVED , setIsListing, setProcessedFiles AFTER USER, ON 23OCT2025
	  
      // 🎯 FIX: Cast result.items to 'any' to avoid the unexported type issue. THIS BLOCK WAS REPLACED BY THE LINES # 217-233.
      // This allows access to the 'key' property without TS error.
      //const fileList: ProcessedFile[] = (result.items as any[])
        //.filter(item => item.key !== PROCESSED_FILES_PREFIX && item.key !== '')
        //.map(item => ({
          //key: item.key,
          //name: item.key, 
          //size: item.size || 0,
        //}));
      
      //setProcessedFiles(fileList);
      //console.log('Processed files listed:', fileList);
    //} catch (error) {
      //console.error('Error listing processed files:', error);
    //} finally {
      //setIsListing(false);
    //}
  //}, [user]);

  //SEPERATE EFFECT TO FETCH PROCESSED FILES WHEN USER IS SET
  useEffect(() => {															//ADDED ON 23OCT2025.
	  if(user) {
		console.log('User authenticated, fetching processed files....');
		fetchProcessedFiles();
	  }
  }, [user, fetchProcessedFiles]);

  // Handle the file download using getUrl (unchanged logic)
  const handleDownload = async (fileKey: string, fileName: string) => {
    //if (!user) return; //BASED ON INPUT FROM QUICKSUITE AGENT ON 22ND OCT.
    setIsDownloading(true);

    try {
      const result = await getUrl({
        key: fileKey,
        options: {
		  bucket: {
			bucketName: DOWNLOAD_BUCKET_NAME, 				//COMMENTED ON 23OCT2025 TO FIX DOWNLOAD OPTION. uncommented on 4thNov2025
			region: DOWNLOAD_BUCKET_REGION   				//uncommented on 4thNov2025
		  },
          expiresIn: 3600//, 							//COMMENTED ON 23OCT2025 TO FIX DOWNLOAD OPTION.
        }
      });
	  
	  // Create download link
	  const link = document.createElement('a');
	  link.href = result.url.toString();
	  link.download = fileName;
	  link.click();

      //const url = result.url.toString();
      
      //window.open(url, '_blank');
      console.log(`Downloaded: ${fileName}`);

    } catch (error) {
      console.error(`Error downloading ${fileName}:`, error);
      //alert(`Could not download ${fileName}. Please check IAM permissions and try again.`);
	  alert(`Download failed. Please try again.`);
    } finally {
      setIsDownloading(false);
    }
  };


  // Handle federated sign-in using Amplify's built-in method (unchanged)
  const handleFederatedLogin = async () => {
    console.log('Button clicked - handleFederatedLogin called');

    try {
      setIsLoading(true);
      console.log('Starting signInWithRedirect...');

      await signInWithRedirect({
        provider: {
          custom: 'FederateOIDC-strategyteamapp'
        }
      });
    } catch (error) {
      console.error('Federated sign-in error:', error);
      alert('Sign-in failed. Please try again.');
      setIsLoading(false);
    }
  };

  // Handle sign-out (unchanged)
  const handleSignOut = async () => {
    try {
      await signOut();
      setUser(null);
      setUploadedFiles([]);
      setProcessedFiles([]);
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };

  // Handle file upload (unchanged logic)
  const handleFileUpload = async (file: File) => {
    if (!file) return;

    // Validate file type (unchanged)
    const allowedTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      '.xlsx',
      '.xls'
    ];
    
    const isExcelFile = allowedTypes.some(type => 
      file.type === type || file.name.toLowerCase().endsWith('.xlsx') || file.name.toLowerCase().endsWith('.xls')
    );

    if (!isExcelFile) {
      setUploadStatus('Error: Please select an Excel file (.xlsx or .xls)');
      return;
    }

    // Validate file size (max 10MB) (unchanged)
    if (file.size > 10 * 1024 * 1024) {
      setUploadStatus('Error: File size must be less than 10MB');
      return;
    }

    setIsUploading(true);
    setUploadStatus('Uploading...');
    setUploadProgress(0);

    try {
      // Create unique file key with custom prefix and timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      const fileKey = `${UPLOAD_KEY_PREFIX}${user?.username || 'anonymous'}/${timestamp}_${file.name}`; 

      // Upload Data - REMOVE the bucket option
      const result = await uploadData({
        key: fileKey,
        data: file,
        options: {
          //bucket: UPLOAD_BUCKET_NAME,
          onProgress: ({ transferredBytes, totalBytes }: TransferProgressEvent) => {
            if (totalBytes) {
              const progress = Math.round((transferredBytes / totalBytes) * 100);
              setUploadProgress(progress);
            }
          },
        }
      }).result;

      console.log('Upload successful:', result);

      // Add to uploaded files list
      const newFile: UploadedFile = {
        name: file.name,
        key: fileKey,
        uploadTime: new Date().toLocaleString()
      };

      setUploadedFiles(prev => [newFile, ...prev]);
      setUploadStatus(`Successfully uploaded: ${file.name}. Processing started...`);
      
      setTimeout(() => setUploadStatus(''), 5000);

    } catch (error) {
      console.error('Upload error:', error);
      setUploadStatus(`Upload failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  // Handle file input change (unchanged)
  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  // Handle drag and drop (unchanged)
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.add('drag-over');
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove('drag-over');
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.currentTarget.classList.remove('drag-over');
    
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      handleFileUpload(files[0]);
    }
  };

  // Set up authentication event listeners (unchanged)
  useEffect(() => {
    console.log('Setting up Hub listener...');

    const unsubscribe = Hub.listen("auth", ({ payload }: { payload: HubPayload }) => {
      const { event, data } = payload;
      console.log('Auth event received:', event, data);

      switch (event) {
        case "signInWithRedirect":
          console.log("User signed in with redirect:", data);
          setTimeout(() => {
            getUser().then((userData) => {
              if (userData) {
                console.log('User data retrieved:', userData);
                setUser(userData);
                fetchProcessedFiles(); 		//COMMENTED TO FOCUS ON UPLOAD FILE FUNCTION ON 23OCT2025. Uncommented on 6thNov2025.
              }
              setIsLoading(false);
            });
          }, 1000);
          break;
        case "signInWithRedirect_failure":
          console.log("Sign in with redirect failure:", data);
          setIsLoading(false);
          alert('Authentication failed. Please try again.');
          break;
        case "signOut":
          console.log("User signed out");
          setUser(null);
          setIsLoading(false);
          break;
        default:
          console.log('Unhandled auth event:', event);
          break;
      }
    });

    getUser().then((userData) => {
      if (userData) {
        console.log('Existing user found:', userData);
        setUser(userData);
        fetchProcessedFiles();                   //COMMENTED TO FOCUS ON UPLOAD FILE FUNCTION ON 23OCT2025. Uncommented on 6thNov2025.
      }
    });

    return unsubscribe;
  }, []);					//REMOVED "fetchProcessedFiles" FROM [] ON 23OCT2025.

  // Common styles... (unchanged)
  const appStyles: React.CSSProperties = {
    textAlign: 'center',
    backgroundColor: '#2c3e50',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white'
  };

  const headerStyles: React.CSSProperties = {
    backgroundColor: '#2c3e50',
    padding: '20px',
    color: 'white',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const logoStyles: React.CSSProperties = {
    height: '80px',
    width: '80px',
    marginBottom: '2rem'
  };


  // Render authenticated user interface
  if (user) {
    return React.createElement('div', 
      { className: 'App', style: appStyles },
      React.createElement('header', 
        { className: 'App-header', style: headerStyles },
        React.createElement('img', {
          src: logo,
          style: logoStyles,
          className: 'spinning-logo',
          alt: 'logo'
        }),
        React.createElement('h1', {
          style: { fontSize: '2rem', marginBottom: '1rem', color: 'white' }
        }, 'Welcome to Strategy Team Application for Closing Codes development'),
        React.createElement('p', {
          style: { fontSize: '1.2rem', marginBottom: '2rem', color: '#4CAF50' }
        }, 'Successfully authenticated!'),
        
        // User info card (unchanged)
        React.createElement(View, {
          style: { marginBottom: '2rem' }
        },
          React.createElement(Card, {
            style: {
              padding: '1rem',
              backgroundColor: '#34495e',
              border: '1px solid #5a6c7d',
              borderRadius: '8px'
            }
          },
            React.createElement('p', {
              style: { margin: '0.5rem 0', color: '#ecf0f1' }
            }, 
              React.createElement('strong', null, 'User: '),
              user.username || user.userId || 'N/A'
            ),
            React.createElement('p', {
              style: { margin: '0.5rem 0', color: '#ecf0f1' }
            },
              React.createElement('strong', null, 'Status: '),
              'Authenticated via Amazon Federate'
            )
          )
        ),

        // File upload section
        React.createElement('div', {
          style: { width: '100%', maxWidth: '600px', marginBottom: '2rem' }
        },
          React.createElement('h2', {
            style: { fontSize: '1.5rem', marginBottom: '1rem', color: 'white' }
          }, `1. Upload FMEA Excel File here`),         //(to ${UPLOAD_BUCKET_NAME}) commented on 6th Nov2025 to make look clean.
          
          // Upload area
          React.createElement('div', {
            className: 'file-upload-area',
            onDragOver: handleDragOver,
            onDragLeave: handleDragLeave,
            onDrop: handleDrop
          },
            React.createElement('p', {
              style: { margin: '0 0 1rem 0', color: '#bdc3c7' }
            }, 'Drag and drop your Excel file here, or click to select'),
            React.createElement('input', {
              type: 'file',
              accept: '.xlsx,.xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              onChange: handleFileInputChange,
              style: { display: 'none' },
              id: 'file-input'
            }),
            React.createElement('label', {
              htmlFor: 'file-input',
              className: 'file-input-label'
            }, 'Select Excel File')
          ),

          // Upload status
          uploadStatus && React.createElement('div', {
            style: { 
              margin: '1rem 0',
              padding: '0.5rem',
              borderRadius: '4px',
              backgroundColor: uploadStatus.includes('Error') ? '#e74c3c' : '#4CAF50',
              color: 'white'
            }
          }, uploadStatus),

          // Upload progress
          isUploading && React.createElement('div', {
            style: { margin: '1rem 0' }
          },
            React.createElement('div', {
              style: {
                width: '100%',
                backgroundColor: '#34495e',
                borderRadius: '4px',
                overflow: 'hidden'
              }
            },
              React.createElement('div', {
                style: {
                  width: `${uploadProgress}%`,
                  height: '20px',
                  backgroundColor: '#4CAF50',
                  transition: 'width 0.3s ease'
                }
              })
            ),
            React.createElement('p', {
              style: { margin: '0.5rem 0', color: '#bdc3c7' }
            }, `Upload Progress: ${uploadProgress}%`)
          )
        ),

        // 🎯 NEW SECTION: Processed Files List (Download)
        React.createElement('div', {
          style: { width: '100%', maxWidth: '600px', marginBottom: '2rem' }
        },
          React.createElement('h2', {
            style: { fontSize: '1.5rem', marginBottom: '1rem', color: 'white' }
          //}, `2. Download Processed Files (from ${DOWNLOAD_BUCKET_NAME} root)`), 
		  }, `2. You will recieve an email with processed file.`),  ///${user.username} ADDED. (from ${DOWNLOAD_BUCKET_NAME}/Translated_public/${user.username}) commented on 6thNov2025.
          
          React.createElement(CloudscapeButton, {                                                     //CHANGED FROM "BUTTON" TO "CLOUDSCAPEBUTTON" (23OCT2025).
            onClick: fetchProcessedFiles,
            loading: isListing,																		  // Changed from isLoading to loading to be in line with changes made on line 673 on 23OCT2025.
            loadingText: 'Refreshing...',
            variant: "normal"//, 									// Changed from variation: "warning" to variant: "normal" to be in line with changes made on line 673 on 23OCT2025.
            //style: {												// COMMENTED WHOLE STYLE BLOCK TO BE COMPLAINT WITH CLOUDSCAPE (23OCT2025).
            //  backgroundColor: '#3498db',
            //  borderColor: '#2980b9',
            //  marginBottom: '1rem',
            //  color: 'white',
            //  cursor: isListing || isDownloading ? 'not-allowed' : 'pointer',
            //}
          }, 'Refresh Processed Files List'),

          // Processed Files List
          React.createElement('div', {
            style: { textAlign: 'left', minHeight: '100px', backgroundColor: '#34495e', padding: '10px', borderRadius: '4px' }
          },
            isListing ? React.createElement('p', null, 'Loading files...') :
            processedFiles.length === 0 ? React.createElement('p', {style: {color: '#bdc3c7'}}, 'No processed files found. Upload a file and wait for processing.') :
            processedFiles.map((file, index) =>
              React.createElement('div', {
                key: index,
                style: {
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '0.5rem',
                  margin: '0.5rem 0',
                  backgroundColor: '#2c3e50',
                  borderRadius: '4px',
                  border: '1px solid #5a6c7d'
                }
              },
                React.createElement('p', {
                  style: { margin: '0', color: '#ecf0f1', fontWeight: 'bold' }
                }, file.name),
                React.createElement(CloudscapeButton, {								//CHANGED FROM "BUTTON" TO "CLOUDSCAPEBUTTON" (23OCT2025).
                  onClick: () => handleDownload(file.key, file.name),
                  variant: "primary",								// Changed from variation: "primarY" to variant: "primary" to be in line with changes made on line 673 on 23OCT2025.
                  disabled: isDownloading//,						// CHANGED FROM "isDisabled: isDownloading" to "disabled: isDownloading" on 23OCT2025.
                  //style: {										// COMMENTED WHOLE STYLE BLOCK TO BE COMPLAINT WITH CLOUDSCAPE (23OCT2025).
                  //  backgroundColor: '#4CAF50',
                  //  borderColor: '#46a049',
                  //  padding: '8px 16px',
                  //  fontSize: '0.9rem',
                  //  color: 'white'
                  //}
                }, isDownloading ? 'Downloading...' : 'Download')
              )
            )
          )
        ),

        // Uploaded files list (unchanged structure)
        uploadedFiles.length > 0 && React.createElement('div', {
          style: { width: '100%', maxWidth: '600px', marginBottom: '2rem' }
        },
          React.createElement('h3', {
            style: { fontSize: '1.2rem', marginBottom: '1rem', color: 'white' }
          }, 'Recently Uploaded Files (Source History)'),
          React.createElement('div', {
            style: { textAlign: 'left' }
          },
            ...uploadedFiles.map((file, index) =>
              React.createElement('div', {
                key: index,
                style: {
                  padding: '0.5rem',
                  margin: '0.5rem 0',
                  backgroundColor: '#34495e',
                  borderRadius: '4px',
                  border: '1px solid #5a6c7d'
                }
              },
                React.createElement('p', {
                  style: { margin: '0', color: '#ecf0f1', fontWeight: 'bold' }
                }, file.name),
                React.createElement('p', {
                  style: { margin: '0.25rem 0 0 0', color: '#bdc3c7', fontSize: '0.9rem' }
                }, `Uploaded: ${file.uploadTime} | Key: ${file.key}`)
              )
            )
          )
        ),

        // Sign out button (unchanged)
        React.createElement(AmplifyButton, {                              //CHANGED FROM "BUTTON" TO "AMPLIFYBUTTON" (23OCT2025).
          onClick: handleSignOut,
          variation: "primary",
          style: {
            backgroundColor: '#e74c3c',
            borderColor: '#c0392b',
            padding: '12px 24px',
            fontSize: '1.1rem',
            marginBottom: '2rem',
            color: 'white'
          }
        }, 'Sign Out')
      )
    );
  }

  // Render sign-in interface (unchanged)
  return React.createElement('div',
    { className: 'App', style: appStyles },
    React.createElement('header',
      { className: 'App-header', style: headerStyles },
      React.createElement('img', {
        src: logo,
        style: logoStyles,
        className: 'spinning-logo',
        alt: 'logo'
      }),
      React.createElement('h1', {
        style: { fontSize: '2rem', marginBottom: '1rem', color: 'white' }
      }, 'Welcome to Strategy Team Application to develop Closing codes'),
      React.createElement('p', {
        style: { fontSize: '1.2rem', marginBottom: '2rem', color: '#bdc3c7' }
      }, 'Please sign in here'),
      React.createElement(AmplifyButton, {										//CHANGED FROM "BUTTON" TO "AMPLIFYBUTTON" (23OCT2025).		
        onClick: handleFederatedLogin,
        isLoading: isLoading,
        loadingText: 'Redirecting to Amazon Federate...',
        variation: 'primary',
        style: {
          backgroundColor: '#ff9900',
          borderColor: '#e68900',
          padding: '12px 24px',
          fontSize: '1.1rem',
          borderRadius: '4px',
          marginBottom: '2rem',
          color: 'white'
        }
      }, 'Sign In with Amazon Federate'),
      React.createElement('p', {
        style: { fontSize: '0.9rem', color: '#95a5a6' }
      }, 'Secure authentication powered by AWS Cognito')
    )
  );
}

export default App;